import React from "react";
import styled from "styled-components";
import { Loading } from "../../../components";
import {
  MATCH_STATUS_HIDDEN,
  MATCH_STATUS_NOT_STARTED,
  MATCH_STATUS_PENDING_DATE,
} from "../../../utils/constants";

const MatchHistory = ({ matches, loading, error, playerId }) => (
  <Wrapper>
    {loading && <Loading />}
    {error && <ErrorText>Error cargando historial</ErrorText>}
    {!loading && !error && matches && (
      <Grid>
        {matches.map((match) => {
          const win =
            (match.playerAid === playerId &&
              (match.playerAresult > match.playerBresult ||
                match.playerAaw === "AW")) ||
            (match.playerBid === playerId &&
              (match.playerBresult > match.playerAresult ||
                match.playerBaw === "AW"));
          const defeat =
            !win &&
            match.status !== MATCH_STATUS_HIDDEN &&
            match.status !== MATCH_STATUS_NOT_STARTED &&
            match.status !== MATCH_STATUS_PENDING_DATE &&
            ((match.playerAid === playerId &&
              match.playerAresult !== null) ||
              (match.playerBid === playerId &&
                match.playerBresult !== null));
          const isHidden = match.status === MATCH_STATUS_HIDDEN;
          const isPending =
            match.status === MATCH_STATUS_NOT_STARTED ||
            match.status === MATCH_STATUS_PENDING_DATE;
          const bye =
            match.playerAusername === "DESCANSA" ||
            match.playerBusername === "DESCANSA";

          const result =
            playerId === match.playerAid
              ? match.playerAresult
              : match.playerBresult;

          return (
            <Pill
              key={`mh-${match.matchId}`}
              $win={win && !bye}
              $defeat={defeat && !bye && !isPending}
              $hidden={isHidden}
              $pending={isPending && !bye}
              $bye={bye}
            >
              {bye ? "-" : isHidden || isPending ? "?" : result ?? "?"}
            </Pill>
          );
        })}
      </Grid>
    )}
  </Wrapper>
);

const Wrapper = styled.div`
  margin-top: 0.75rem;
`;

const ErrorText = styled.p`
  font-family: var(--v-font-body);
  font-size: 12px;
  color: var(--v-fg-muted);
`;

const Grid = styled.div`
  display: flex;
  gap: 4px;
`;

const Pill = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;

  background: ${({ $win, $defeat, $hidden, $pending, $bye }) =>
    $win
      ? "var(--v-mint)"
      : $defeat
      ? "var(--v-uv)"
      : $bye
      ? "rgba(255,255,255,0.06)"
      : $hidden
      ? "transparent"
      : "rgba(255,255,255,0.04)"};

  color: ${({ $win, $defeat, $bye }) =>
    $win
      ? "#000"
      : $defeat
      ? "#fff"
      : $bye
      ? "var(--v-fg-muted)"
      : "var(--v-fg-muted)"};

  border: ${({ $hidden }) =>
    $hidden ? "1px solid rgba(255,255,255,0.08)" : "none"};
`;

export default MatchHistory;
